import PropTypes from 'prop-types';
import { QUESTION_TYPE } from '../../../utils/constants';
import { SingleMultiQuestion } from './SingleMultiQuestion';
import { TextQuestion } from './TextQuestion';
import useVideo from '../../../hooks/useVideo';
import { AnimatePresence } from 'framer-motion';

const questionComponent = {
    [QUESTION_TYPE.TextQuestion]: TextQuestion,
    [QUESTION_TYPE.SingleQuestion]: SingleMultiQuestion,
    [QUESTION_TYPE.MultiQuestion]: SingleMultiQuestion
}

export function SliceQuestion(props) {

    const { onAnswer, currentQuestion, show, typeOfQuestion } = props;
    const { pause } = useVideo();
    const CurrentComponent = questionComponent[typeOfQuestion];

    const sendResponse = (answer) => {
        const userAnswer = {
            answer,
            type: currentQuestion.interactionTypeQuestion
        }
        onAnswer(userAnswer);

        if (currentQuestion.feedback) pause();
    }

    const stopPropagation = (e) => {
        e.stopPropagation();
    }

    return (
        <AnimatePresence>
            {show && (
                <CurrentComponent
                    answers={currentQuestion.answers}
                    correctAnswers={currentQuestion.correctAnswers}
                    onAnswer={sendResponse}
                    typeOfQuestion={typeOfQuestion}
                    onClick={stopPropagation}
                    previousAnswers={currentQuestion.answer?.answer}
                />
            )}
        </AnimatePresence>
    )
}

SliceQuestion.propTypes = {
    currentQuestion: PropTypes.object,
    onAnswer: PropTypes.func,
    show: PropTypes.bool,
    typeOfQuestion: PropTypes.string
}